import '../../styles/components/pageHeader.scss';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { Breadcrumb, Button, Space } from 'antd';
import classNames from 'classnames';
import { getBreadcrumbNameMap, getPath } from '@/scripts/utils';
import { ArrowLeftOutlined } from '@ant-design/icons';

/**
 * Props
 * title:string - 主标题
 * content:any - 内容
 * extra:any - 额外元素
 * sticky:boolean - 吸顶
 * allowBack:boolean - 显示返回按钮
 */
export default function PageHeader(props) {
    const { title, content, extra, sticky, allowBack } = props;

    // 获取面包屑
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const pathSnippets = pathname
        .split('/')
        .filter((i) => i)
        .slice(1);
    const breadcrumbNameMap = getBreadcrumbNameMap();
    const breadcrumbItems = pathSnippets.map((item, index) => {
        const url = pathSnippets.slice(0, index + 1);
        return {
            key: item,
            title: <Link to={getPath(url)}>{breadcrumbNameMap[item]}</Link>,
        };
    });

    return (
        <div className={classNames('ax-page-header', { 'ax-sticky': !!sticky })}>
            {/*<Breadcrumb items={breadcrumbItems} className="ax-page-header__breadcrumb" />*/}
            <div className="ax-page-header__main">
                <Space align="center">
                    {allowBack && <Button type="text" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}></Button>}
                    {!!title && <div className="ax-page-header__title">{title}</div>}
                </Space>
                <div>{extra}</div>
            </div>
            {!!content && <div className="ax-page-header__content">{content}</div>}
        </div>
    );
}
